<script>
  // import { getContext } from 'svelte'
  import { line } from 'd3-shape'
  import { fly, fade, slide, draw } from 'svelte/transition'
  let showLine = true

  let line_gen
  export let scale
  export let stroke = 'red'
  export let strokeWidth = 1
  export let values
  export let data
  export let height, width

  // let { nData } = getContext('chart')
  // let data = nData()
  // console.log(data)

  $: line_gen = line()
    .x((d) => scale.x(d[values.x]))
    .y((d) => scale.y(+d[values.y]))

  $: if (data) {
    showLine = false
    setTimeout(() => {
      showLine = true
    }, 100)
  }
</script>

{#if showLine}
  <!-- Add background line -->
  <path
    class="chart-line chart-line-one"
    style="stroke: white; stroke-width: {strokeWidth * 2}px;"
    d={line_gen(data)}
  />
  <!-- Chart line -->
  <path
    class="chart-line chart-line-one"
    style="stroke: {stroke}; stroke-width: {strokeWidth}px;"
    d={line_gen(data)}
  />
{/if}

<style>
  path {
    stroke: #333;
    stroke-width: 5px;
  }
</style>
